const mutations = {
  setServiceRequestList(state, data) {
    state.serviceRequestList = data;
  },
  setServiceRequest(state, data) {
    state.serviceRequest = data;
  },
  resetServiceRequest(state) {
    state.serviceRequest = {
      date: new Date(),
      userId: null,
      isOnSite: true,
      createdBy: null,
      serviceJobsMeta: [],
      customerCall: false,
      isSiteVisited: false,
      externalGoodsMeta: {},
      externalGoodsTotal: 0,
      priority: "moderate",
      customerAddressId: null,
      temporaryPhone: null
    };
  },
  setServiceRequestSaleId(state, saleId) {
    state.serviceRequest.saleId = saleId;
  },
  setServiceRequestLogs(state, payload) {
    state.serviceRequestLogs = payload;
  },
  setServiceRequestPointsTimeline(state, payload) {
    state.serviceRequestPointsTimeline = payload || {
      totalPoints: 0,
      totalPenalty: 0,
      totalAwardedPoints: 0,
      unlinkedAwardedPoints: 0,
      unlinkedPointLogs: [],
      allPointLogs: [],
      timeline: []
    };
  },
  setServiceRequestStats(state, data) {
    state.serviceRequestStats = data;
  }
};
export default mutations;
